import { render, staticRenderFns } from "./ReporteBien.vue?vue&type=template&id=1f962ae0"
import script from "./ReporteBien.vue?vue&type=script&lang=js"
export * from "./ReporteBien.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports